function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#E5F6ED"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_171_2084)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.9994 21.466L26.2299 27.6963C26.635 28.1019 27.2906 28.1019 27.6957 27.6963C28.1008 27.2912 28.1008 26.6356 27.6957 26.2305L21.4652 20.0002L27.6957 13.77C28.1008 13.3649 28.1008 12.7098 27.6957 12.3042C27.2906 11.8986 26.635 11.8986 26.2299 12.3042L19.9994 18.5345L13.7689 12.3042C13.3638 11.8986 12.7082 11.8986 12.3031 12.3042C12.1008 12.506 11.9996 12.7715 11.9996 13.0371C11.9996 13.3026 12.1013 13.5677 12.3031 13.77L18.5336 20.0002L12.3031 26.2305C12.1008 26.4328 11.9996 26.6979 11.9996 26.9634C11.9996 27.2289 12.1013 27.494 12.3031 27.6963C12.7082 28.1019 13.3638 28.1019 13.7689 27.6963L19.9994 21.466Z",
  fill: "#00A94F"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_171_2084"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(28 12) rotate(90)"
})));

function SvgIconBoxWidgetsMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxWidgetsMenuClose);
export default __webpack_public_path__ + "static/media/icon_box-widgets-menu-close.04d141fd.svg";
export { ForwardRef as ReactComponent };